module.exports = __webpack_public_path__ + "media/images/element/20-0c8c76719783ebf1aa0dc86d8d960946.svg";